/*
*   查询区高级查询弹出框组件  --wangshhj
* */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import Ajax from 'src/api/ajax';
// import { promptBox } from 'src';
import { PubSub } from '@platform/api';
import { getSysFieldid, toast, isFunction, isArray, isEmpty } from '@platform/api';
import { Select as NCSelect, Tabs as NCTabs, Input as NCFormControl, Radio as NCRadio, Tooltip as NCTooltip, HotKeys as NCHotKeys, Tree as NCTree, Icon as NCIcon, Checkbox as NCCheckbox } from '@platform/base';
import { getTimezoneOffset, _clone as deepClone, setDefaultScheme, snapshotFilter, tree2Array, beSureBtnClick, beSureBtnClick_Del, spreadQueryPlan, _clone } from './_methods';
import {
    _getAllSearchData,
    delNode,
    setSearchValByFieldHigh as setSearchValByField,
    getCurrentTemplate,
    _addData,
    clearAllValue,
    replaceData,
    createOperation,
    setMultiLangHigh as setMultiLang,
} from './methods';
import { templateEngine } from './templateEngine';
import { promptBox } from '../PromptBox';

// import toast from '../../api/toast';
// import getSysFieldid from '../../api/getSysFieldid';

require('./searchAdvModal.less');
require('./tree.less');

const NCTabPane = NCTabs.TabPane;
const NCTreeNode = NCTree.TreeNode;
const NCOption = NCSelect.Option;
const NCRadioGroup = NCRadio.RadioGroup;
// 查询区渲染完成发布订阅标识
const BEFORECOMPLETE = 'beforeAreaChangeComplete'
const COMPLETE = 'areaChangeComplete';

/*
*   SearchAdvModal组件，props中的参数解释：
*
*   moduleId ,                   //查询区组件id
*	advMeta ,                    //查询区模板
*	closeModal ,                 //关闭组件方法
*	searchBtnClick ,             //查询按钮回调
*	onAfterEvent ,               //编辑后事件
*   showAdvSearchPlanBtn ,       //是否显示保存方案按钮 ，默认显示
*   replaceAdvBody ,             //替换高级查询body区域
*   addAdvTabs ,                 //添加自定义tab页签
*   addAdvBody ,                 //添加自定义查询条件
*   replaceRightBody ,           //添加高级查询区右侧区域自定义查询条件Dom (fun)
*   searchPlanCache ,            //查询方案数据
*   searchPlanCacheChange ,      //查询方案修改后，回调
*   oid ,                        // 查询模板的oid
*   hideSearchCondition = false, // 隐藏候选条件
*   hideSearchPlan = false       // 隐藏高级查询的查询方案
*   saveSearchPlan,              // 保存查询方案确定按钮事件 ，用于业务组返回自定义的查询条件
*   clickPlanEve,                // 点击高级面板中的查询方案事件 ,用于业务组为自定义查询区赋值
*   advSearchClearEve,           // 高级面板中的清空按钮点击事件回调，用于业务组清除自定义查询条件的值
* */
export default class SearchAdvCom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: props.searchInfo.status,
            showModal: false,//该参数用来表示高级弹窗是否刚打开
            moveNode: null, // 拖拽节点
            leftTab: props.hideSearchCondition ? '2' : (props.searchInfo.leftTab || '1'), // 左侧tab的key值
            currentPlan: null,
            checked: false,
            showSearchNameTip: false
            //isDefaultPlan:null,
            //searchPlanName:null

        };
        this.setStateEve = props.setStateEve;
        this.initByProps(props, true);
    }

    componentDidMount() {
        if (!isFunction(this.props.replaceAdvBody) && !this.props.hideSearchCondition) {
            //每次更新高级查询都更新左侧的内容
            this.createSearchCondition.call(this, this.items);
        }
        // 没办法了 只能通过全局订阅发布做了 
        this.searchChoosePlan = PubSub.subscribe('searchChoosePlan', (msg, data) => {
            console.log(msg, data, 'searchChoosePlan只能通过全局订阅发布做了');
            if (data) {
                let currentPlan = this.props.searchInfo.searchPlanCache.find(item => item.name == data);
                if (currentPlan) {
                    this.setState({ currentPlan });
                    this.clickSearchPlan(currentPlan);
                }
            }
        });

    }

    componentWillUnmount() {
        this.props.searchInfo.isRenderAdv = false;
        this.searchChoosePlan && PubSub.unsubscribe(this.searchChoosePlan);
    }

    componentWillReceiveProps(props) {
        if (props.onlyShowAdvArea || props.searchInfo.showAdvModal) {
            this.initByProps(props, false);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (!nextProps.onlyShowAdvArea && !nextProps.searchInfo.showAdvModal) {
            return false
        }
        return true
    }

    //flag标识是否第一次初始化
    initByProps = (props, flag) => {
        let searchInfo = props.searchInfo;
        let showModal = this.state.showModal;//false:标识刚打开，true标识已经打开
        let currentPlan, status;
        if (showModal) {
            currentPlan = this.state.currentPlan;
            status = this.state.status;

        } else {
            currentPlan = searchInfo.currentClickPlan || searchInfo.currentPlan // 当前正在操作的查询方案
            status = searchInfo.status;
            this.state.searchPlanName = currentPlan.name;
            if (props.onlyShowSuperCondition || (currentPlan && !isEmpty(currentPlan.renderobj4web_snap) && currentPlan.renderobj4web_snap[0].attrcode == 'root')) {
                status = 'super';
            } else {
                status = 'normal';
            }
        }
        let items = props.meta.items || [];
        this.items = items;
        /* 添加树组件需要的字段 */
        items.forEach(item => {
            if (!item.hasOwnProperty('attrcode')) {
                console.error('查询模板中有字段缺少attrcode字段，请检查');
            }
            if (!item.hasOwnProperty('label')) {
                console.error('查询模板中有字段缺少label字段，请检查');
            }
            item.refpk = item.attrcode;
            item.refname = item.advLable || item.label;
            item.isleaf = true;
        });
        // 当业务组要替换整个body区域或者不需要候选条件时，不加载候选条件；首次渲染不执行，在componentDidMount中执行
        if (!isFunction(props.replaceAdvBody) && !props.hideSearchCondition && !flag) {
            //每次更新高级查询都更新左侧的内容
            this.createSearchCondition.call(this, items);
        }

        // 当业务组需要替换整个body区或者替换右侧body区域时，不默认加载右侧
        if (!isFunction(props.replaceAdvBody) && !isFunction(props.replaceRightBody)) {
            let isDefaultPlan = currentPlan.pk_ncc_queryscheme == '001';
            let currentSnap = deepClone(currentPlan.renderobj4web_snap);
            let defaultSnap = deepClone(searchInfo.defaultPlan.renderobj4web);

            if (!showModal) {
                this.tabIndex = this.tabIndex || '0';
                if (isFunction(props.addAdvTabs)) {
                    let def = [...props.addAdvTabs()];
                    for (let index = 0; index < def.length; index++) {
                        const element = def[index];
                        if (element.defaultOpen === true) {
                            if (this.props.isShowDefalutPage) {
                                this.tabIndex = String(index + 1);
                            } else {
                                this.tabIndex = String(index)
                            }
                            break;
                        }

                    }
                }
                if (isDefaultPlan) {
                    if (status == 'super' && !props.onlyShowSuperCondition) {
                        searchInfo.snapshotMap.normal = spreadQueryPlan(props.context, defaultSnap, searchInfo.itemsMap);
                        spreadQueryPlan(props.context, currentSnap, searchInfo.itemsMap)
                        searchInfo.snapshotMap.super = currentSnap;
                    } else if (status == 'super' && props.onlyShowSuperCondition) {
                        if (currentSnap && currentSnap.length && currentSnap[0].attrcode == 'root') {
                            searchInfo.snapshotMap.super = currentSnap;
                        } else {
                            searchInfo.snapshotMap.super = [{
                                attrcode: 'root',
                                refpk: 'root',
                                key: 'root',
                                operationSign: 'and',
                                noRemove: true, //不可移除
                                children: spreadQueryPlan(props.context, currentSnap, searchInfo.itemsMap),
                                visible: true,
                            }]
                        }
                    } else {
                        searchInfo.snapshotMap.normal = spreadQueryPlan(props.context, currentSnap, searchInfo.itemsMap);
                        searchInfo.snapshotMap.super = [
                            {
                                attrcode: 'root',
                                refpk: 'root',
                                key: 'root',
                                operationSign: 'and',
                                noRemove: true, //不可移除
                                children: deepClone(searchInfo.snapshotMap.normal),
                                visible: true,
                            }
                        ];
                    }

                } else {
                    if (status == 'super') {
                        if (currentSnap && currentSnap.length && currentSnap[0]) {
                            searchInfo.snapshotMap.super = spreadQueryPlan(props.context, currentSnap, searchInfo.itemsMap);
                        } else {
                            searchInfo.snapshotMap.super = [{
                                attrcode: 'root',
                                refpk: 'root',
                                key: 'root',
                                operationSign: 'and',
                                noRemove: true, //不可移除
                                children: spreadQueryPlan(props.context, currentSnap, searchInfo.itemsMap),
                                visible: true,
                            }]
                        }
                        searchInfo.snapshotMap.normal = spreadQueryPlan(props.context, defaultSnap, searchInfo.itemsMap);
                    } else {
                        searchInfo.snapshotMap.normal = spreadQueryPlan(props.context, currentSnap, searchInfo.itemsMap);
                        searchInfo.snapshotMap.super = [{
                            attrcode: 'root',
                            refpk: 'root',
                            key: 'root',
                            operationSign: 'and',
                            noRemove: true, //不可移除
                            children: spreadQueryPlan(props.context, defaultSnap, searchInfo.itemsMap),
                            visible: true,
                        }]
                    }
                }
            } else {
                console.log('gaoji已经打开');
            }
        }
        searchInfo.currentClickPlan = null;
        this.state.showModal = true;
        this.state.currentPlan = currentPlan;
        // this.state.searchPlanName = currentPlan.name;
        searchInfo.status = status;
        this.state.status = status;
    };

    /* setState */
    setMyStateEve = callback => {
        this.setState(this.state, callback);
    };



    // 从meta里面获取 候选条件树
    getConditionTreeFromItems = items => {
        items.forEach(item => {
            if (!item.hasOwnProperty('attrcode')) {
                console.error(this.multiLang['page-search-0026'] + 'attrcode' + this.multiLang['page-search-0027'] + '，' + this.multiLang['page-search-0028']);
            }
            if (!item.hasOwnProperty('label')) {
                console.error(this.multiLang['page-search-0026'] + 'label' + this.multiLang['page-search-0027'] + '，' + this.multiLang['page-search-0028']);
            }
            item.refpk = item.attrcode || '';
            item.refname = item.label || '';
            !item.pid && delete item.pid;
        });
        return this.props.syncTree.createTreeData(items);
    };

    /* 查询按钮点击事件 */
    searchBtnClickEve = async () => {
        let data = null;
        let template = [];
        const snapshot = this.props.searchInfo.snapshotMap[this.state.status];

        // 如果业务组替换整个body或者右侧body区域，则需要业务组自己组织自定义查询条件
        if (isFunction(this.props.replaceRightBody) || isFunction(this.props.replaceAdvBody)) {
            /* 此时查询按钮的回调方法中，data为 'userControl'，表示需要业务组自己处理自定义的查询条件 */
            data = 'userControl';
            if (isFunction(this.props.searchBtnClick)) {
                let f = await this.props.searchBtnClick({ ...this.props._this._this, ...this.props._this._this.props },
                    data, 'super');
                if (!f) {
                    this.props.searchInfo.status = "simple";
                    this.close(true);
                }
            }

        } else {
            data = _getAllSearchData(this.props.searchInfo, this.props.context, true);
            template = getCurrentTemplate(this.props.searchInfo);

            if (data !== false) {
                let finalData = {
                    queryAreaCode: this.props.moduleId,
                    oid: this.props.oid || this.props.meta.oid,
                    querytype: 'tree',
                    querycondition: data,
                    template,
                    nctz: getTimezoneOffset(),

                };
                if (isFunction(this.props.searchBtnClick)) {
                    let clickResult = await this.props.searchBtnClick({ ...this.props._this._this, ...this.props._this._this.props }, data, 'super', data && finalData);
                    if (!clickResult) {
                        if (this.props.syncAdvCondition) {
                            this.props.searchInfo.snapshotMap['simple'] = snapshot;
                            this.state.currentPlan.renderobj4web_snap = snapshot;
                            this.props.searchInfo.currentPlan = this.state.currentPlan || {};
                        }
                        this.close(true);
                    }
                } else {
                    if (this.props.syncAdvCondition) {
                        this.props.searchInfo.snapshotMap['simple'] = snapshot;
                        this.state.currentPlan.renderobj4web_snap = snapshot;
                        this.props.searchInfo.currentPlan = this.state.currentPlan || {};
                    }
                    this.close(true);
                }
            }
        }
    };

    /* 取消 */
    cancelClick = e => {
        if (e) e.stopPropagation();
        const { backPosition } = this.props;
        isFunction(backPosition) && backPosition();
        if (this.props._this._this.state.modal['addSearchPlan@' + this.props.moduleId].showModal) {
            this.props.modal.close('addSearchPlan@' + this.props.moduleId)
        } else if (this.props._this._this.state.modal['editSearchPlanName@' + this.props.moduleId].showModal) {
            this.props.modal.close('editSearchPlanName@' + this.props.moduleId)
        } else {
            if (!this.props.hideSearchCondition) {
                this.props.syncTree.setSearchValue(this.props.moduleId);
            }
            this.close();
        }
    };

    /* 保存方案按钮 */
    saveSearchPlanClick = () => {
        beSureBtnClick.call(this.props._this, 'save', false, this.state.currentPlan, this.state.searchPlanName, false, this);
    };

    /* 新增方案按钮 */
    addSearchPlanClick = () => {
        this.props.modal.show('addSearchPlan@' + this.props.moduleId);
    };

    /* 关闭模态框 */
    close = flag => {
        const { onlyShowModalCancelCallback, onlyShowModal } = this.props;
        let statusChangeEvent = this.props.statusChangeEvent;
        statusChangeEvent && statusChangeEvent('simple');
        !flag && onlyShowModal && isFunction(onlyShowModalCancelCallback) && onlyShowModalCancelCallback();
        this.props.searchInfo.status = 'simple';
        PubSub.publishSync(BEFORECOMPLETE, true);
        this.props._this._this.infoExchangeController.publishSync('heightChange', { area: 'searchArea' });
        this.setState({ showModal: false }, () => {
            this.props._this._this.infoExchangeController.publishSync('heightChange', { area: 'searchArea' });
            // 发布通知表格更新高度
            PubSub.publish(COMPLETE, true);
        });
        document.body.style.overflow = 'auto';
        this.props.closeModal(flag);
    };

    /* 字段操作符change事件 */
    mathSignChange = (data, val, oldValue) => {
        if (val !== 'between' && oldValue === 'between') {
            data.initialvalue.value = '';
            data.initialvalue.display = '';
        } else if (val === 'between' && oldValue !== 'between') {
            data.initialvalue.display = [];
            data.initialvalue.value = [];
        }
        data.operationSign = val;
        this.setStateEve(() => {
            typeof this.props.onOperateTypeChange === 'function' && this.props.onOperateTypeChange(data.attrcode, val);
        });
    };

    /* 拖拽到节点 */
    onDropChildren = e => {
        e.preventDefault();
        const keys = JSON.parse(e.currentTarget.getAttribute('keys'));
        this.state.targetKey = keys.attrcode;
        this.state.targetIsExtend = keys.isExtend;
    };

    /* 拖拽经过节点 */
    onDragOver = e => {
        e.preventDefault();
        return true;
    };

    /* 父节点操作符change事件 */
    logicSelectChange = (data, val, oldval) => {
        if (data.attrcode === 'root' && data.attrcode === 'root') {
            data.operationSign = val;
            this.forceUpdate();
        } else {
            setSearchValByField.call(this.props._this._this, this.props.moduleId, data.refpk, data, val);
        }
    };

    /* 左侧tab ，change事件 */
    tabChange = val => {
        if (val === '2') {
            //如果还没查询过查询方案，去查询  暂时注释掉
            //this.querySearchPlan();
        }
        this.setState({ leftTab: val });
    };

    /* 创建左侧查询条件区域 */
    createSearchCondition = items => {
        //去掉固定条件和模板不显示的项
        let cloneItems = _clone(items);
        let _item = cloneItems.filter(item => {
            if (item.message) {
                item.customerIconRender = () =>
                    <NCTooltip
                        delayShow={800}
                        // delayHide={1}
                        inverse
                        overlay={item.message}
                        placement="rightTop"
                    >
                        <span className='NC_iconBox tooltip-icon'><i className={"iconfont icon-wenhao-m"} /></span>
                    </NCTooltip>;

            }
            return item.isfixedcondition != true
        });
        let tree = this.props.syncTree.createTreeData(_item);
        this.props.syncTree.setSyncTreeData(this.props.moduleId, tree, null, false);

    };


    /*拖拽元素在目标元素头上移动的时候*/
    onDragOver = e => {
        e.preventDefault();
        return true;
    };

    //单击箭头添加查询条件
    clickRight = () => {
        this.onDrop('clickRight');
    };

    /* 拖到普通查询的区域 */
    onDrop = flag => {
        if (flag === 'clickRight') {
            //hover 候选条件的时候 出现的右侧单击箭头，点击的时候获得node
            this.state.moveNode = deepClone(this.props.syncTree.getHoverNodeKey(this.props.moduleId));
        } else {
            this.state.moveNode = deepClone(this.props.syncTree.getMoveNodeKey(this.props.moduleId));
        }

        //如果拖拽的节点是数组并且第一项的isdrag为false或者 节点为对象并且isdrag 为false，不允许拖拽
        if (
            (isArray(this.state.moveNode) && this.state.moveNode[0].isdrag === false) ||
            this.state.moveNode.isdrag === false
        ) {
            return;
        }
        // if (this.state.moveNode.onlyOne === true) {
        if (this.state.status === 'normal') {
            //平铺方案，有过已经存在就结束
            let snapshot = this.props.searchInfo.snapshotMap[this.state.status].filter(item => item.visible !== false);
            let snapShot_list = tree2Array(snapshot);
            if (snapShot_list.find(i => i.attrcode === this.state.moveNode.attrcode)) {
                return;
            }
        }
        if (this.state.moveNode.hasOwnProperty('children')) {
            delete this.state.moveNode.children;
        }

        _addData.call(this, this.state.moveNode, this.state.status);
        //this.scrollBottom('normal');
    };

    //让制定ref的容器滚动条滚到最下方
    scrollBottom = ref => {
        // let target = this.refs[ref];
        // const clientHeight = target.clientHeight;
        // const scrollHeight = target.scrollHeight;
        // target.scrollTop = clientHeight + scrollHeight;
    };

    /* 清空值 */
    clearAdvValue = () => {
        isFunction(this.props.advSearchClearEve) && this.props.advSearchClearEve();
        //同步内外的status
        this.props.searchInfo.status = this.state.status;
        clearAllValue.call(this.props._this._this, this.props.moduleId);
    };


    /* 修改查询方案名称 */
    // 修改名称项 不一定是当前项  editPlanName
    editSearchPlanName = (item, e) => {
        // e.stopPropagation()  
        this.clickSearchPlan(item);
        this.props.modal.show('editSearchPlanName@' + this.props.moduleId);

    };

    /* 删除查询方案 */
    delSearchPlan = item => {
        this.clickSearchPlan(item);
        // this.state.currentPlan = item;
        promptBox({
            color: 'warning',
            hotKeyboard: true,
            title: this.multiLang['page-search-0031'],
            content: <div>{this.multiLang['page-search-0015']}</div>, // 提示内容,非必输
            beSureBtnName: this.multiLang['page-search-0009'], // 确定按钮名称, 默认为"确定",非必输
            cancelBtnName: this.multiLang['page-search-0010'],
            beSureBtnClick: beSureBtnClick_Del.bind(this.props._this, false, this.state.currentPlan.pk_ncc_queryscheme, this),
        });
    };

    /* 为查询方案中,未填写项添加标识。用于点击方案后，在页面展示 */
    addMark = data => {
        data.map(item => {
            if (
                item.initialvalue &&
                (item.initialvalue.value === '' ||
                    item.initialvalue.value === null ||
                    (isArray(item.initialvalue.value) && !item.initialvalue.value.length) ||
                    (isArray(item.initialvalue.value) && item.initialvalue.value[0] === null))
            ) {
                item.isEmpty = true;
            } else {
                item.isEmpty = false;
            }
            if (Array.isArray(item.children)) {
                this.addMark(item.children);
            }
        });
    };

    /* 点击查询方案 */
    clickSearchPlan = (item, e) => {
        if (item.pk_ncc_queryscheme == this.state.currentPlan.pk_ncc_queryscheme) return;
        item.renderobj4web && item.renderobj4web.forEach(val => (val.advrequired = !!val.required));
        this.state.currentPlan = item;
        // this.state.isDefaultPlan = item.pk_ncc_queryscheme == '001';
        this.state.searchPlanName = item.name;
        const extendsList = this.props.searchInfo.fixedConditionGroup;
        isFunction(this.props.clickPlanEve) && this.props.clickPlanEve(item, this.props._this._this);
        if (item.renderobj4web && item.renderobj4web.length && item.renderobj4web[0].refpk === 'root') {
            //高级
            this.state.status = 'super';
            this.props.searchInfo.status = 'super';
            item.renderobj4web[0].children = extendsList.concat(item.renderobj4web[0].children);
            let plan = item.renderobj4web;
            this.props.searchInfo.snapshotMap.super = spreadQueryPlan(this.props.context, plan, this.props.searchInfo.itemsMap);
        } else {
            //普通
            this.state.status = 'normal';
            this.props.searchInfo.status = 'normal';
            let plan = item.renderobj4web;
            if (item.pk_ncc_queryscheme == '001') {
                this.props.searchInfo.snapshotMap.normal = spreadQueryPlan(this.props.context, plan, this.props.searchInfo.itemsMap);
            } else {
                let filterFix = Array.isArray(plan) ? plan.filter(item => {
                    let fixCondition = extendsList.find(a => a.attrcode == item.attrcode);
                    if (fixCondition) {
                        return false;
                    } else {
                        return true;
                    }
                }) : [];
                this.props.searchInfo.snapshotMap.normal = spreadQueryPlan(this.props.context, [...extendsList, ...filterFix], this.props.searchInfo.itemsMap);
            }

        }
        //同步内外状态

        isFunction(this.props.setInitValueEvent) && this.props.setInitValueEvent(this.state.status);
        let statusChangeEvent = this.props.statusChangeEvent;
        statusChangeEvent && statusChangeEvent(this.state.status);
        this.setMyStateEve();
    };

    /* 创建查询方案dom */
    createSearchPlan = () => {
        let newCache = Array.isArray(this.props.searchInfo.searchPlanCache) ? [...this.props.searchInfo.searchPlanCache] : [];
        /*ajax*/
        if (!newCache.length) {
            return (
                <li className="searchPlanList">
                    <span className="searchPlanName">{this.multiLang['page-search-0029']}</span>
                </li>
            );
        }

        return newCache.map(item => {
            let defaultDisPlay = this.props.meta.defaultDisPlay;
            if (defaultDisPlay === '00000000000000000000') {
                defaultDisPlay = '001';
            }
            let iconClass = item.pk_ncc_queryscheme === (defaultDisPlay || this.props.meta.defaultPrepared) ? ' iconfont-def' : '';
            return (
                <li className={`searchPlanList ${this.state.currentPlan.name == item.name ? 'active' : ''}`} key={item.pk_ncc_queryscheme} >
                    <NCTooltip
                        delayShow={800}
                        inverse
                        overlay={this.state.showSearchNameTip ? <div>{item.name}</div> : null}
                        placement="top"
                    >
                        <span className="searchPlanName"
                            onClick={this.clickSearchPlan.bind(this, item)}
                            onMouseOver={(e) => {
                                e.stopPropagation();
                                if (e.target && e.target.scrollWidth > e.target.clientWidth) {
                                    if (this.state.showSearchNameTip) return;
                                    this.setState({ showSearchNameTip: true });
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!this.state.showSearchNameTip) return;
                                this.setState({ showSearchNameTip: false });
                            }}
                        >
                            {item.name}
                        </span>
                    </NCTooltip>
                    {iconClass && <i className="iconfont iconfont-default-hover icon-sheweimoren" />}
                    <span className='searchPlanSet'>
                        {!item.isprepared && (
                            <NCTooltip
                                placement="top"
                                overlay={this.multiLang['page-search-0092']}//重命名
                                delayHide={1}
                                delayShow={1000}
                            >
                                <i className='iconfont searchPlanEdit icon-gerenpeizhi' onClick={this.editSearchPlanName.bind(this, item)} />
                            </NCTooltip>
                        )}
                        {!item.isprepared && (
                            <NCTooltip
                                placement="top"
                                overlay={this.multiLang['page-search-icon-delete']}
                                delayHide={1}
                                delayShow={1000}
                            >
                                <i className='iconfont searchPlanDel icon-shanchu' style={{ marginRight: this.props.showAdvSetDefault ? '10px' : '0px' }} onClick={this.delSearchPlan.bind(this, item)} />
                            </NCTooltip>
                        )}
                        {this.props.showAdvSetDefault && <NCTooltip
                            placement="top"
                            overlay={iconClass ? this.multiLang['page-search-0097'] : this.multiLang['page-search-0095']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i className={'iconfont searchPlanDef icon-sheweimoren' + iconClass}
                                onClick={e => {
                                    e.stopPropagation();
                                    if (iconClass) return;
                                    setDefaultScheme.call(this.props._this, true, item, item.pk_ncc_queryscheme, this.props.oid);
                                }}
                            />
                        </NCTooltip>}
                    </span>

                </li>
            );
        });
    };

    /* 方案名称change事件 */
    searchPlanNameChange = val => {
        this.setState({ searchPlanName: val });
    };

    /* 运算符change事件 */
    mathSignChangeEve = (treeData, pk, val) => {
        let len = treeData.length;
        while (len--) {
            let item = treeData[len];
            if (item.refpk === pk) {
                /* 处理between和非between类型切换时，数据格式处理。between数据类型为数组，起始和结束的值都为切换前的value值。非between类型时，数据格式为字符串，取between的起始值 */
                if (val !== 'between' && item.operationSign === 'between') {
                    item.initialvalue.value = '';
                    item.initialvalue.display = '';
                } else if (val === 'between' && item.operationSign !== 'between') {
                    item.initialvalue.display = [];
                    item.initialvalue.value = [];
                }
                item.operationSign = val;
                return true;
            } else if (Array.isArray(item.children)) {
                let res = this.mathSignChangeEve(item.children, pk, val);
                if (res) {
                    return false;
                }
            }
        }
    };

    /* 修改方案模态框 */
    modalContent = status => {
        let checked = status === "add";
        return (
            <div className="plan-content">
                <span className="label">{this.multiLang['page-search-0012'] + ' '}</span>
                <span className="content">
                    <NCHotKeys
                        keyMap={{
                            high: [
                                'enter',
                            ],
                        }}
                        handlers={{ high: beSureBtnClick.bind(this.props._this, status, false, this.state.currentPlan, this.state.searchPlanName, this.state.checked, this) }}
                    >
                        <NCFormControl
                            id="NC_searchPlanModalInput"
                            autoFocus
                            className="searchPlanModal"
                            value={this.state.searchPlanName}
                            onChange={this.searchPlanNameChange.bind(this)}
                            maxlength={100}
                        />
                    </NCHotKeys>
                </span>
                {checked && this.props.showAdvSetDefault && <div className="setdefault" onClick={() => {
                    this.setState({ checked: !this.state.checked })
                }}>
                    <NCCheckbox checked={this.state.checked} onClick={() => {
                        this.setState({ checked: !this.state.checked })
                    }} />
                    <span className="default-lable">{this.multiLang['page-search-0099']}</span>
                </div>}

            </div>
        );
    };

    // 生成查询条件单元
    createDomItem = snapshotItem => {
        let templetItem = this.props.searchInfo.itemsMap[snapshotItem.attrcode];
        let renderItem = this.props.renderItem;
        if (!templetItem) {
            return null;
        } else {
            return new templateEngine({
                moduleId: this.props.moduleId,
                searchInfo: this.props.searchInfo,
                snapshotItem,
                isAdvDom: true,
                onAfterEvent: this.props.onAfterEvent,
                setStateEve: this.setStateEve,
                renderItem,
                context: this.props.context,
                showRequire: false,
                showPlaceholder: false,
                hiddenFunList: this.props.hiddenFunList,
                multiLang: this.multiLang,
                LangData: this.LangData,
            });
        }
    };

    /* 生成查询条件 */
    createDom = status => {
        if (typeof status === 'string') {

            var snapshot = this.props.searchInfo.snapshotMap[status].filter(item => item.visible !== false);

        } else if (typeof status === 'object') {
            var snapshot = status.filter(item => item.visible);
        }
        if (!snapshot.length) {
            return;
        }
        let snapshot_list = tree2Array(snapshot);
        let itemsMap = this.props.searchInfo.itemsMap;
        snapshot_list.forEach(element => {
            if (element.visible !== false) {
                let operationOptions = createOperation(itemsMap[element.attrcode].queryOperateType);
                if (operationOptions.length > 0) {
                    if (!operationOptions.some(i => element.operationSign === i.value)) {
                        element.operationSign = (operationOptions[0] && operationOptions[0].value) || element.operationSign || '=';
                        // element.initialvalue = { display: '', value: '' };
                    }
                    element.operationOptions = operationOptions;
                }

            }
        });
        return snapshot.map((data, ind) => {
            //  必输项标识
            let item = this.props.searchInfo.itemsMap[data.attrcode];
            if (!item && !data.attrcode.includes('root')) {
                return null;
            }
            let mustFillIn = null;
            if (item && item.required) {
                mustFillIn = <div className="mustFillIn iconfont icon-xinghao"></div>;
            }

            let searchChildDom = this.createDomItem(data);

            /* 树节点dom */
            const treeTitle = () => {
                let logicOptions = {
                    and: this.multiLang['page-search-0035'],
                    or: this.multiLang['page-search-0036'],
                };

                if (data.children && data.children.length) {
                    const hasRequire = data.children.some(item => this.props.searchInfo.itemsMap[item.attrcode] && this.props.searchInfo.itemsMap[item.attrcode].required, this);
                    return (
                        <div className="advancedSearchSign">
                            <div
                                key={data.refpk} // 疑问：key为什么没设置上？？？_targetInit中是null
                                keys={JSON.stringify({ attrcode: data.refpk, isExtend: !!data.isExtend })}
                                // field={data.refpk}
                                className="advancedSearchChild"
                                onDrop={this.onDropChildren}
                                onDragOver={this.onDragOver}
                            >
                                {data.attrcode === 'root' && hasRequire ? (
                                    <div className="advancedSearch_root">{logicOptions[data.operationSign]}</div>
                                ) : (
                                    <div className="select-containter">
                                        <NCSelect
                                            className="NC_logicSign"
                                            showClear={false}
                                            value={String(data.operationSign || 'and')}
                                            onChange={this.logicSelectChange.bind(this, data)}
                                            fieldid={data.attrcode}
                                        >
                                            {Object.keys(logicOptions).map((val, index) => {
                                                return (
                                                    <NCOption key={index} value={String(val)}>
                                                        {logicOptions[val]}
                                                    </NCOption>
                                                );
                                            })}
                                        </NCSelect>
                                    </div>

                                )}
                            </div>
                            {!data.noRemove &&
                                !data.isfixedcondition && (
                                    <div className="searchAdvCom_remove" onClick={this.removeDom.bind(this, data)}>
                                        {this.multiLang['page-search-0037']}
                                    </div>
                                )}
                        </div>
                    );
                } else {
                    if (data.operationOptions) {

                        let selectDom = (
                            <div
                                className="NC_searchAdvCom"
                                key={data.refpk}
                                keys={JSON.stringify({ attrcode: data.refpk, isExtend: !!data.isExtend })}
                                onDrop={this.onDropChildren}
                                onDragOver={this.onDragOver}
                            >

                                <span className='remove'>{data.remove ? (
                                    <div className="searchAdvCom_remove" onClick={this.removeDom.bind(this, data)}>
                                        <i className='iconfont icon-qingkong' />
                                    </div>
                                ) : <div className="searchAdvCom_remove">{this.state.status === 'super' ? <div className="link" /> : null}</div>}
                                </span>
                                <span className='content'>
                                    {mustFillIn}
                                    <NCTooltip
                                        delayShow={800}
                                        inverse
                                        overlay={<div>{item.advLable || item.label}</div>}
                                        placement="top"
                                    >
                                        <div className="searchAdvCom_name">{item.advLable || item.label}</div>
                                    </NCTooltip>

                                    <div className="searchAdvCom_select">
                                        {data.operationOptions.length > 1 ? (

                                            <NCSelect
                                                className="NC_operateSign"
                                                showClear={false}
                                                disabled={!!item.disabled}
                                                value={String(data.operationSign || this.multiLang['page-search-0035'])}
                                                onChange={this.mathSignChange.bind(this, data)}
                                                fieldid="operateSign"
                                            >
                                                {data.operationOptions.map((val, index) => {
                                                    return (
                                                        <NCOption key={index} value={String(val.value)}>
                                                            {val.display}
                                                        </NCOption>
                                                    );
                                                })}
                                            </NCSelect>

                                        ) : (
                                            <span className="option-label">{(data.operationOptions[0] || {}).display}</span>
                                        )}
                                    </div>
                                    <div className="searchAdvCom_com">{searchChildDom}</div>
                                </span>

                            </div>

                        );

                        return selectDom;
                    } else {
                        console.log('the data is', data);
                    }
                }
            };

            if (data.children && data.children.length) {
                let logicOptions = {
                    and: this.multiLang['page-search-0035'],
                    or: this.multiLang['page-search-0036'],
                };
                const children = data.children;
                return (
                    <NCTreeNode
                        key={data.refpk + ind}
                        title={treeTitle.call(this, data)}
                        className="search-right-area-tree-node"
                        liAttr={{ fieldid: getSysFieldid(logicOptions[data.operationSign] + '_node') }}
                    >
                        {this.createDom(children)}
                    </NCTreeNode>
                );
            }

            return (
                <NCTreeNode
                    key={data.attrcode + ind}
                    title={treeTitle.call(this, data)}
                    liAttr={{ fieldid: getSysFieldid(data.attrcode + '_node') }}
                    className={`search-right-area-tree-node${this.state.status === 'super' ? ' child-node' : ''}`}
                />
            );
        }).filter(item => item);

    };

    /* 移除控件 */
    removeDom = data => {
        const { status, snapshotMap } = this.props.searchInfo;
        const queryconditionCount = snapshotMap[status].filter(item => item.attrcode === data.attrcode).length;
        if (!this.props.removeQuerConditionEve || !this.props.removeQuerConditionEve.call(this.props._this._this, this.props.moduleId, data.attrcode, queryconditionCount)) {
            this.state.targetKey = null;
            delNode.call(this.props._this._this, this.props.moduleId, data.refpk);
        }

        // isFunction(advData.remove) && advData.remove(this.comId)
    };

    onDragEnterBox = () => {
        this.state.targetKey = null;
    };

    creatConditionUIDom = data => {
        return (
            <div
                id={this.props.moduleId}
                ref={dom => this.NCSearchAdvComBox = dom}
                className="NC_searchAdvComBox"
                // onDrop={ onDrop.bind(this)}
                onDragEnter={this.onDragEnterBox.bind(this)}
                fieldid={getSysFieldid('advSearch_tree-area')}
            >
                {/*console.log("refs is",this.refs)*/}
                <div fieldid={getSysFieldid('advSearch_tree')} className='advSearch_tree'>
                    <NCTree
                        // showLine = {false}
                        // selectedKeys = { thisTree.selectedValue }
                        // onSelect = { onSelect.bind(this) }
                        // onExpand={ onExpand.bind(this) }    //  节点展开事件
                        // expandedKeys={ [] }    //搜索节点关键字后要展开的父节点
                        // autoExpandParent={ thisTree.autoExpandParent }    //是否展开所有节点
                        // onMouseLeave={ onMouseLeave.bind(this) }    //鼠标离开节点事件
                        // onMouseEnter={ onMouseEnter.bind(this) }    // 鼠标进入节点事件
                        // multiple = {true} //是否允许选择多个节点
                        // closeIcon={(
                        //     <p className="tree-icon-content">
                        //         <NCIcon className="first" type="uf-add-s-o" />
                        //         <NCIcon className="secend" type="uf-minus" />
                        //         <NCIcon className="third" type="uf-treefolderopen" />
                        //     </p>
                        // )}
                        // openIcon={(
                        //     <p className="tree-icon-content">
                        //         <NCIcon className="first" type="uf-reduce-s-o" />
                        //         <NCIcon className="secend" type="uf-minus" />
                        //         <NCIcon className="third" type="uf-treefolderopen" />
                        //     </p>
                        // )}
                        // draggable
                        // onDragEnter={ onDragEnter.bind(this) }
                        // onDragOver={ onDragOverBox.bind(this) }
                        // onDragStart={ onDragStart.bind(this) }
                        // onDrop = { onDrop.bind(this) }
                        defaultExpandedKeys="root0"
                        className={this.state.status === 'super' ? 'superTree' : 'normalTree'}

                    >
                        {this.createDom(data)}
                    </NCTree>
                </div>

            </div>
        );
    };

    handleChange(value) {
        this.state.status = value;
        this.props.searchInfo.status = value;
        let statusChangeEvent = this.props.statusChangeEvent;
        statusChangeEvent && statusChangeEvent(this.state.status);
        this.setMyStateEve();
    }

    /* 默认右侧区域dom */
    defRightDom = () => {
        let searchStatus = this.state.status;
        if (this.props.onlyShowSuperCondition) {
            searchStatus = 'super';
        }
        return (
            <div className="adv-right-area" id="adv-right-area">
                {isFunction(this.props.addAdvBody) && this.props.addAdvBody()}
                {!this.props.hideSearchType && <NCRadioGroup selectedValue={searchStatus} onChange={this.handleChange.bind(this)}>
                    <NCRadio value='normal'>{this.multiLang['page-search-0006']}</NCRadio>
                    <NCRadio value='super'>{this.multiLang['page-search-0007']}</NCRadio>
                </NCRadioGroup>}
                {searchStatus === 'normal' && (
                    <div
                        className="normalArea"
                        id="advArea"
                        style={{ height: isFunction(this.props.addAdvBody) || this.props.hideSearchType ? 'auto' : 'calc(100% - 40px)' }}
                        onDragOver={this.onDragOver}
                        onDrop={this.onDrop.bind(this)}
                    >
                        {this.creatConditionUIDom('normal')}
                    </div>
                )}
                {searchStatus === 'super' && (
                    <div id="advArea" className="superArea" style={{ height: isFunction(this.props.addAdvBody) || this.props.onlyShowSuperCondition ? 'auto' : 'calc(100% - 40px)' }} onDragOver={this.onDragOver} onDrop={this.onDrop.bind(this)}>
                        {this.creatConditionUIDom('super')}
                    </div>
                )
                }
            </div>
        );
    };

    tabOnChange = e => {
        this.tabIndex = e;
        e = Number(e);
        if (e > 0 && isFunction(this.props.addAdvTabs)) {
            let callback = this.props.addAdvTabs()[e - 1].callback;
            isFunction(callback) && callback();
        }
        this.setMyStateEve();
    }

    /* 创建右侧区域dom */
    createRightDom = () => {
        let def = [
            {
                name: this.props.searchConditionName || this.multiLang['page-search-0025'],
                content: this.defRightDom(),
            },
        ];
        if (isFunction(this.props.addAdvTabs)) {
            if (this.props.isShowDefalutPage) {
                def = [...def, ...this.props.addAdvTabs()];
            }
            else {
                def = [...this.props.addAdvTabs()];
            }
        }
        return def;
    };
    onInputFocus = () => {
        document.getElementById('NC_searchPlanModalInput').focus()
    }
    render() {
        this.multiLang = this.props.multiLang;
        this.LangData = this.props.LangData;
        let { AdvModalHeight=525 } = this.props;
        setMultiLang(this.multiLang);
        return (
            <div className="modalBody" style={{ height: (AdvModalHeight - 85) + 'px' }}>

                {/* 业务组替换高级面板的整个body区域时，不加载公共查询条件，只加载自定义条件 */}
                {isFunction(this.props.replaceAdvBody) && this.props.replaceAdvBody()}

                {!isFunction(this.props.replaceAdvBody) && (
                    <div className="modalBodyBox">
                        <div className="leftArea" fieldid={getSysFieldid('left_area')}>
                            <NCTabs
                                defaultActiveKey="1"
                                onChange={this.tabChange.bind(this)}
                                activeKey={this.state.leftTab}
                                tabBarStyle="noborder"
                                className="searchTabStyle"
                            >
                                {!this.props.hideSearchCondition && (
                                    // <NCTabPane tab={this.multiLang['page-search-0004']} key="1">
                                    <NCTabPane
                                        tab={(
                                            <div className={this.state.leftTab == '1' && 'tab-label-in'}>{this.multiLang['page-search-0004']}</div>
                                        )}
                                        key="1"
                                    >
                                        {this.props.syncTree.createSyncTree({
                                            treeId: this.props.moduleId,
                                            showLine: false,
                                            neverDisable: true,
                                            expandedKeys: ['root'],
                                            onDoubleClickEve: this.clickRight,
                                            // metaId:'treeForm',  // 树模板的id
                                            needEdit: false, //是否需要编辑节点功能，默认为true,可编辑；false：不可编辑
                                            draggable: true,
                                            needDrop: false,
                                            searchType: 'filtration',
                                            nodeRightOpt:
                                                this.state.status === 'normal'
                                                    ? {
                                                        icon: 'uf-triangle-right',
                                                        callback: this.clickRight,
                                                    }
                                                    : false,
                                        })}
                                    </NCTabPane>
                                )}

                                {!this.props.hideSearchPlan && (<NCTabPane
                                    tab={(
                                        <div className={this.state.leftTab == '2' && 'tab-label-in'}>{this.multiLang['page-search-0005']}</div>
                                    )}
                                    key='2'
                                // key={this.state.planTabKey}
                                >
                                    <ul className="searchPlanUl">{this.createSearchPlan()}</ul>
                                </NCTabPane>)}
                            </NCTabs>
                        </div>

                        <div className="rightArea" fieldid={getSysFieldid('rigit_area')} style={{ overflow: isFunction(this.props.replaceRightBody) ? 'auto' : 'hidden' }}>
                            {isFunction(this.props.replaceRightBody) && this.props.replaceRightBody()}
                            {!isFunction(this.props.replaceRightBody) && (
                                <span className="clearData" onClick={this.clearAdvValue}>
                                    {this.multiLang['page-search-0017']}
                                </span>
                            )}
                            {!isFunction(this.props.replaceRightBody) && (
                                <NCTabs style={{ height: '100%' }} className="lucia" onChange={this.tabOnChange.bind(this)} activeKey={this.tabIndex || '0'}>
                                    {this.createRightDom().map((e, i) => {

                                        return (
                                            <NCTabPane tab={e.name} key={i}>
                                                {e.content}
                                            </NCTabPane>
                                        );
                                    }, this)}
                                </NCTabs>
                            )}
                        </div>
                    </div>
                )}
                {/** 修改方案名称弹窗 */}
                {!isEmpty(this.multiLang) && this.props.modal.createModal('editSearchPlanName@' + this.props.moduleId, {
                    title: this.multiLang['page-search-0082'],
                    content: this.modalContent.call(this, 'edit'),
                    beSureBtnClick: () => { beSureBtnClick.call(this.props._this, 'edit', false, this.state.currentPlan, this.state.searchPlanName, false, this) },
                    leftBtnName: this.multiLang['page-search-0009'],
                    rightBtnName: this.multiLang['page-search-0010'],
                    zIndex: 310,
                    onEntered: this.onInputFocus,
                    // size: 'sm',
                    minHeight: 140,
                    minWidth: 400,
                    width: 400,
                    className: 'search-modal',
                })}
                {/** 另存新方案弹窗 */}
                {!isEmpty(this.multiLang) && this.props.modal.createModal('addSearchPlan@' + this.props.moduleId, {
                    title: this.multiLang['page-search-0081'],
                    content: this.modalContent.call(this, 'add'),
                    // size: 'sm',
                    minHeight: 170,
                    minWidth: 400,
                    width: 400,
                    backdrop: 'static',
                    cancelBtnClick: () => { this.setState({ checked: false }) },
                    closeModalEve: () => { this.setState({ checked: false }) },
                    beSureBtnClick: () => beSureBtnClick.call(this.props._this, 'add', false, this.state.currentPlan, this.state.searchPlanName, this.state.checked, this),
                    leftBtnName: this.multiLang['page-search-0009'],
                    rightBtnName: this.multiLang['page-search-0010'],
                    zIndex: 310,
                    onEntered: this.onInputFocus,
                    className: 'search-modal',

                })}
            </div>
        );
    }
}
